import { useContext } from "react";
import { CartContext } from "../context/CartContext";
import { useNavigate } from "react-router-dom";

function CartDrawer({ open, onClose }) {

const { cartItems, removeFromCart } = useContext(CartContext);
const navigate = useNavigate();

const totalPrice = (Array.isArray(cartItems) ? cartItems : []).reduce(
  (total, item) =>
    total + (item.variant?.price || 0) * (item.quantity || 1),
  0
);

return (

<div
  className={`fixed inset-0 z-50 transition ${
    open ? "visible" : "invisible"
  }`}
>

  <div
    className={`absolute inset-0 bg-black/40 transition ${
      open ? "opacity-100" : "opacity-0"
    }`}
    onClick={onClose}
  />

  <div
    className={`absolute right-0 top-0 h-full w-96 bg-white shadow-xl p-6 transition-transform ${
      open ? "translate-x-0" : "translate-x-full"
    }`}
  >

    <h2 className="text-xl font-semibold mb-6">
      Your Cart
    </h2>

    {cartItems.length === 0 ? (
      <p>Your cart is empty</p>
    ) : (

      <div className="space-y-5">

        {(Array.isArray(cartItems) ? cartItems : []).map(item => {

          const product = item.variant?.product;

          return (
            <div key={item.id} className="flex items-center gap-4">

              <img
                src={
                  product?.images?.[0]?.imageUrl ||
                  "/images/placeholder.png"
                }
                alt={product?.name}
                className="w-16 h-16 object-cover rounded"
              />

              <div className="flex-1">
                <p className="font-medium text-sm">
                  {product?.name}
                </p>

                <p className="text-gray-500 text-sm">
                  {item.variant?.size}
                </p>

                <p className="text-gray-500 text-sm">
                  ₹ {item.variant?.price} × {item.quantity}
                </p>
              </div>

              <button
                onClick={() => removeFromCart(item.id)}
                className="text-red-500 text-sm"
              >
                Remove
              </button>
            </div>
          );
        })}

        <hr/>

        <div className="flex justify-between font-semibold">
          <span>Total</span>
          <span>₹ {totalPrice}</span>
        </div>

        <button
          onClick={()=>navigate("/checkout")}
          className="w-full bg-purple-600 text-white py-3 rounded-lg"
        >
          Checkout
        </button>

      </div>

    )}

  </div>

</div>
);

}

export default CartDrawer;